import { render, staticRenderFns } from "./asset.vue?vue&type=template&id=215a05ca&scoped=true"
import script from "./asset.vue?vue&type=script&lang=js"
export * from "./asset.vue?vue&type=script&lang=js"
import style0 from "./asset.vue?vue&type=style&index=0&id=215a05ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215a05ca",
  null
  
)

export default component.exports